import { Button, UIHeading2, UIText2, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import { IBank } from 'shared/types/banksList';

import * as styles from './CianMortgageBanner.css';

export interface ICianMortgageBannerProps {
  monthlyPayment: string;
  url: string;
  banks: IBank[];
  randomBanks: IBank[];
  onClick?(event: React.MouseEvent): void;
}

export const CianMortgageBanner: React.FC<React.PropsWithChildren<ICianMortgageBannerProps>> = ({
  monthlyPayment,
  onClick,
  url,
  banks,
  randomBanks,
}) => {
  const hiddenBanksLength = banks.length > randomBanks.length ? banks.length - randomBanks.length : 0;

  return (
    <a
      className={styles['banner']}
      href={url}
      onClick={onClick}
      rel="noopener noreferrer"
      target="_blank"
      data-testid="CianMortgageBanner"
    >
      <div className={styles['logo-and-banks']}>
        <div className={styles['logo']} />
        {randomBanks.length > 0 && (
          <div className={styles['banks']}>
            {randomBanks.map(bank => {
              return (
                <div key={bank.id} className={styles['circle']}>
                  <div className={styles['bank-logo']} style={{ backgroundImage: `url("${bank.logo}")` }} />
                </div>
              );
            })}
            {hiddenBanksLength > 0 && (
              <div className={styles['circle']}>
                <UIText3>+{hiddenBanksLength}</UIText3>
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles['payment']}>
        <UIText2>Ежемесячный платеж</UIText2>
        <UIHeading2 data-mark="BannerMonthlyPayment">{monthlyPayment}</UIHeading2>
      </div>
      <div className={styles['button']}>
        <Button type="button" fullWidth>
          Подать заявку онлайн
        </Button>
      </div>
    </a>
  );
};
